import React from 'react'
import cn from 'classnames'

import { CheckboxProps } from '@components/Checkbox/interface'
import { CheckIcon } from '@components/icons/CheckIcon'

const Checkbox = ({
  label,
  disabled,
  className,
  checked,
  ...props
}: CheckboxProps) => {
  return (
    <label
      data-test={props.name}
      id={props.name}
      className={cn(
        'flex items-center w-full cursor-pointer dark:text-dark-10',
        className
      )}
    >
      <input
        className='hidden'
        type='checkbox'
        disabled={disabled}
        checked={checked}
        {...props}
      />
      <div
        className={cn(
          'relative min-h-[24px] min-w-[24px] h-[24px] w-[24px] border rounded-[8px]',
          {
            'bg-gray-8 border-gray-9 dark:opacity-50 cursor-default': disabled,
            'bg-white dark:bg-dark-10 border-gray-3 dark:border-dark-10':
              !checked,
            'bg-primary dark:bg-purple border-primary dark:border-primary':
              checked,
          }
        )}
        onClick={event => event.stopPropagation()}
      >
        <CheckIcon
          className={cn(
            'text-white dark:text-white-2 absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2',
            {
              hidden: !checked,
            }
          )}
          width='18'
          height='18'
        />
      </div>

      {label && <div className={cn('ml-[10px]')}>{label}</div>}
    </label>
  )
}

export default Checkbox
